// const categories = [
//   {
//     label: "Art",
//     color: "success",
//     variant: "filled",
//   },
//   {
//     label: "Culture",
//     color: "primary",
//     variant: "filled",
//   },
//   {
//     label: "Lifestyle",
//     color: "secondary",
//     variant: "filled",
//   },
//   {
//     label: "Health",
//     color: "info",
//     variant: "filled",
//   },
//   {
//     label: "News",
//     color: "error",
//     variant: "filled",
//   },
//   {
//     label: "Travel",
//     color: "success",
//     variant: "outlined",
//   },
//   {
//     label: "Poetry",
//     color: "error",
//     variant: "outlined",
//   },
//   {
//     label: "Psychology",
//     color: "warning",
//     variant: "outlined",
//   },
// ];

// export default categories;

const categories = [
  "Art",
  "Culture",
  "Lifestyle",
  "Health",
  "News",
  "Travel",
  "Poetry",
  "Psychology",
];

export default categories;
